import React, { useState } from 'react'
import './styles.scss'
import { config } from './config'
import { TileMap } from './tilemap'
interface Props extends answerTheQuestionProps {}

export const SwissTileResolve = ({
  allAnswers,
  userAnswer,
  options,
  correctAnswer
}: Props) => {
  let sum = Object.values(allAnswers).reduce((a, b) => a + +b, 0)
  let max = Math.max.apply(Math, Object.values(allAnswers).map(Number))
  let colorValues: { [key: string]: [number, number] } = {}

  Object.keys(allAnswers).map(m => {
    colorValues[m] = [
      +allAnswers[m],
      +((+allAnswers[m] * 100) / sum).toFixed(1)
    ]
  })

  return (
    <div className='SwissTileResolve'>
      <TileMap
        answers={colorValues}
        user={userAnswer}
        correct={correctAnswer + ''}
        max={(max * 100) / sum}
      />
    </div>
  )
}
